__turbopack_context__.v({
  "icon": "agnt-text-icon-module-scss-module__MjYAeG__icon",
  "link": "agnt-text-icon-module-scss-module__MjYAeG__link",
  "toneBlue": "agnt-text-icon-module-scss-module__MjYAeG__toneBlue",
  "toneNavy": "agnt-text-icon-module-scss-module__MjYAeG__toneNavy",
});
